import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";
import "../../components/new.css";
import "../../components/new1.css";

const icon1 = "https://winpeforum.com/assets/elements/CDPQ_mem1.jpg";

const icon2 = "https://winpeforum.com/assets/elements/AparajitaAhuja.jpeg";

const icon3 = "https://winpeforum.com/assets/elements/MansiAggarwal.png";

const icon4 = "https://winpeforum.com/assets/elements/DianeJegam.jpg";

const icon5 = "https://winpeforum.com/assets/elements/PadmajaRuparel.jpg";
 
let duration = 400;

 
const I14 = "https://www.winpeforum.com/assets/sheshines/24jan2024/14.jpg";
const I15 = "https://www.winpeforum.com/assets/sheshines/24jan2024/15.jpg";
const I16 = "https://www.winpeforum.com/assets/sheshines/24jan2024/16.jpg";
const I17 = "https://www.winpeforum.com/assets/sheshines/24jan2024/17.jpg";
const I18 = "https://www.winpeforum.com/assets/sheshines/24jan2024/18.jpg";
const I19 = "https://www.winpeforum.com/assets/sheshines/24jan2024/19.jpg";
 
 
const II14 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/14.jpg";
const II15 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/15.jpg";
const II16 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/16.jpg";
const II17 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/17.jpg";
const II18 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/18.jpg";
const II19 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/19.jpg";

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
    
    this.Speaker1 = [
     
        {
            imgUrl: icon1,
            desc: `<div>
            Anita M. George is Executive Vice-President and Deputy Head of CDPQ Global. She fills a key role in developing CDPQ’s activities in its three priority international areas: the United States/Latin America, Europe and Asia Pacific. She actively participates in positioning CDPQ internationally, as well as developing and executing its globalization strategy. In addition to her role managing the international offices, Ms. George contributes to diversifying the portfolio by taking a holistic view in approaching the various markets. She sits on CDPQ’s Investment-Risk Committee.<br/><br/>
        
        Ms. George joined CDPQ in April 2016 as Managing Director, South Asia. She was then appointed as Executive Vice-President, Growth Markets and prior to her current role was Executive Vice-President and Head of Strategic Partnerships, Growth Markets. She has extensive knowledge of several of these markets, in addition to possessing a strong ability to develop and strengthen enduring and quality partnerships.<br/><br/>
        
        She has a strong track record in managing infrastructure investment portfolios on a global scale. Prior to joining CDPQ, she was Senior Director of the World Bank’s Energy and Extractive Industries Global Practice. She also held the positions of Director, Infrastructure and Natural Resources of the International Finance Corporation, a member of the World Bank Group, and Head of Siemens Financial Services in India. Her various roles have led her to work in several regions of the world, including Europe, Asia, the Middle East, Africa and Latin America.<br/><br/>
        
        Ms. George holds a BA in Economics and Spanish from Smith College, in Massachusetts, and a Masters in Economics and an MBA in Finance from Boston University.
        
                </div>`,
            name: "Anita George",
            post: `<div>Co-Founder<br/>
            Edhina Capital
            
            </div>`,
          },
         
          {
            imgUrl: icon2,
            desc: `<div>
            Aparajita is Partner and CFO at CX Partners, a leading Private Equity group in the Indian mid-market. Currently, she is on the Board of Betterplace. Previously she has served on the boards of DT Group, Veeda Clinical Research and TSI Pvt Ltd. She has been part of the vibrant Private Equity sector since 2008.<br/><br/>
        
            She is a qualified Chartered Accountant and holds an undergraduate degree in Commerce from the University of Delhi.
            
        
        
            </div>`,
            name: "Aparajita Ahuja",
            post: `<div>Partner & CFO<br/>CX Partners
        
        
            </div>`,
          },
        
         
        
          {
            imgUrl: icon4,
            desc: `<div>
            Diane Jegam is the Regional Director of Proparco South Asia, covering the origination of both debt and equity investments in the region. Since joining French Development Agency in 2008, Diane held different positions within the group with a focus in Africa and has worked in numerous impactful sectors.
            <br/><br/>
        Before this posting in India, she held the position of Deputy Director of the French Development Agency (AFD) in Dakar (2017 – 2021), one of the important office of AFD Group network.
        
        
        
            </div>`,
            name: "Diane Jegam",
            post: `<div>Regional Director South Asia	<br/>
            Proparco
            
            
            </div>`,
          },
          {
            imgUrl: icon3,
            desc: `<div>
            Mansi Aggarwal is a Partner at Alkemi Growth Capital. She has build and invest in leading and sustainable healthcare and consumer companies in India, with a portfolio of over 10 (and counting!) innovative and disruptive startups. With over 15+ years of experience as an investor, banker, and entrepreneur, she has a deep understanding of the opportunities and challenges in these sectors, and a passion for creating positive social impact.
    <br/><Br/>
    Her journey as a business leader began with her education in dental surgery and MBA, followed by involvement in the Stanford Biodesign program, where she co-founded and exited a medical device startup. She also hold 6 patents in healthcare and biotechnology and has been recognized for her achievements in Indian and global forums. She leverages her diverse background, skills, and network to support the growth and success of the companies she invest in and partner with.
      
            
            </div>`,
            name: "Mansi Aggarwal",
            post: `<div>Partner
    <br/>
            Alkemi Growth Capital
            
      
      
            </div>`,
          },
          {
            imgUrl: icon5,
            desc: `<div>
            Padmaja Ruparel is nationally recognized as a key player in the Indian entrepreneurial ecosystem and has helped co-found many of the relevant institutions, besides being an active Angel investor herself. Her operating experience spans large corporates, M&A, and startups/early stage companies. 
            <br/><br/>
        She has been awarded as one of the 'Top 50 Most Powerful Women in Business' by Fortune India for 2017, 2018 2019, listed in Forbes India's WPower Trailblazers and “30 Most Powerful Women in India” by Business Today for 3 years running. The Women Economic Forum recognized her with its “Women of the Decade in Investment Banking” award. 
        <br/><br/>
        She is Co-Founder & President of Indian Angel Network (IAN), India's first and now possibly one of the world's largest group of business angels, comprising the who's who of successful entrepreneurs and dynamic CEOs from India and overseas. She built IAN from inception, making it within 15 years a unique institution globally, with close to 500 investors across 10 countries and a portfolio of 175+ companies in 7 countries, spanning 17 sectors. She has operationalised IAN's international operations in London - making it the only angel group in the world to set up operations outside of its home country. Padmaja has been nominated as Co Chair of Global Business Angel Network (GBAN). She is a member of the National Expert Advisory Committee on Innovation, Incubation and Technology Entrepreneurship. She is a member of several committees of BIRAC (Dept. of Biotech, Govt. of India), various committees of the Ministry of Finance, DPIIT, & SEBI. 
        <br/><br/>
        Padmaja is the Senior Managing Partner of the IAN Fund, a uniquely differentiated Fund which along with IAN, is set to create the largest horizontal platform in India for investing in seed and early stage ventures. 
        <br/><br/>
        She is a member of the Governing Council of EM3 Services, a nation building venture seeking to create a paradigm shift in the Indian agricultural sector by improving productivity. Padmaja is an Independent Director on the Boards of Avendus Finance Pvt. Ltd. & Ester Industries Ltd. 
        <br/><br/>
        Apart from cofounding IAN, she also set up and operationalised the Delhi chapter of The Indus Entrepreneurs (TIE) the world's largest organization focused on entrepreneurship with over 16,000 members across more than 60 chapters across 14 countries. She also established a unique model of an incubator, in partnership with the Indian Government, leveraging 400 mentors to provide mentoring & domain expertise to around 50 young fledgling incubated companies. She played a key role as Executive Director in building the Indian Venture Capital Association, India's oldest and largest association of VC and PE firms. Currently, she is a member of IVCA's Limited Partners Council. 
        <br/><br/>
        She helped the creation of the Lankan Angel Network in Sri Lanka. She contributed actively in the Planning Commission's Committee on “Angel & Early Stage Investing in India” which resulted in a seminal report: “Creating a Vibrant Entrepreneurial Ecosystem in India”.
        <br/><br/>
        In her corporate avatar at Xansa India, (Xansa was a US$800mn company listed on LSE before being acquired by Steria), she led several functions over a 16 year period : handled recruitment operations, built and successfully executed an innovative brand and communication strategy and led the corporate social responsibility initiative which engaged employees, clients as also the government. She was a key member of the corporate strategy and M&A team as the Company went public, forged joint ventures and the final acquisition of the Indian company. 
        <br/><br/>
        Padmaja picked up entrepreneurial strings very early in her career - she revived and grew the family real estate business in Calcutta - growing from 50,000 sq ft to over 250,000 sq ft over 2 years and turned it around to become a profitable business. 
        <br/><br/>
        A graduate with English Honours, Padmaja then completed her MBA as well as Chartered Accountancy (Intermediate) with her internship with S.R. Batliboi (an E&Y group company).
        
        
        
            </div>`,
            name: "Padmaja Ruparel",
            post: `<div>Co-Founder & President<br/>
            Indian Angel Network
            
            
            </div>`,
          },
    ];
    this.CollegiumsImages = [
      { id:45, ImgSrc: I14, ImgSrc1: II14,},   
        { id:19, ImgSrc: I15, ImgSrc1: II15,},   
        { id:49, ImgSrc: I16, ImgSrc1: II16,},  

        { id:21, ImgSrc: I17, ImgSrc1: II17,},    
        { id:20, ImgSrc: I18, ImgSrc1: II18,},  
        { id:14, ImgSrc: I19, ImgSrc1: II19,},   

        
      
    
    ];
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="EmpowerHer: Winpe PEVC Career Portal"
          image={"https://winpeforum.com/assets/ignite/cover.png"}
          description="CV In, Stress Out: Let's Ignite Up Your PEVC Future. Maximize Impact, Harness The Power of PEVC Insights and Accelerate Your Job Search with Our Panel of Experts."
          location={location} 
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper" style={{paddingTop:'110px', minHeight:'auto'}}>
            
            <div className="toastshine_section">
         <a href="https://forms.gle/JS5XPGKmCV5TJzjz7">   <img className="main-img-1" src="https://winpeforum.com/assets/ignite/Home3.jpg" alt="About Image" style={{width:'100%'}}/></a>
               </div> </div>
            <div className="container " style={{paddingTop:'40px', minHeight:'540px'}}>
            
            <div className="col-lg-5 col-md-5 col-sm-12">
              <br/>   <h1 className=" title" style={{color:'#bf2026', fontWeight:'700', textAlign:'left'}}>
                
            IGNITE THE POSSIBILITIES</h1><br/> 
            <div className="top_text" style={{width:'100%'}}>
            <ul style={{textAlign:'left', color:'#22316b', fontSize:'20px', fontWeight:'600', lineHeight:'30px'  
            }}>
                <li style={{paddingBottom:'10px'}}>Exclusive Job Opportunities</li>  
                <li style={{paddingBottom:'10px'}}>Power-packed Resource Hub                 </li> 
                <li style={{paddingBottom:'10px'}}>Robust Community Access 
                </li>  
                <li style={{paddingBottom:'10px'}}>Power Training Sessions             </li> 
                <li style={{paddingBottom:'10px'}}>Masterclasses with Experts  </li> 
                <li style={{paddingBottom:'10px'}}>CV Visibility–Get Your CV on Recruiters' Radar</li> 
                <li style={{paddingBottom:'10px'}}>Insider Tips from Recruiters                </li>
                <li style={{paddingBottom:'10px'}}>1:1 Sessions with Industry Leaders
                </li>
            </ul>
           
            </div>
             
             
          
            </div>
               
            <div className="col-lg-7 col-md-7 col-sm-12">

               
              <a href="https://chat.whatsapp.com/JeAI8cBNsvSBtwY5jzNk6Y" target="_blank"><img className="main-img-1" src="https://winpeforum.com/assets/ignite/whatsapp4.png" alt="About Image" style={{width:'100%', paddingTop:'53px'}}/></a>

              </div></div>
              <div style={{backgroundImage:'url(https://winpeforum.com/assets/ignite/bg1.png)', height:'auto', minHeight:'540px' , width:'100%',  backgroundSize:'cover' }}>

              <div className="container"><br/><br/> 
<div className="top_text" style={{width:'100%', textAlign: 'left', color:'#22316b' , paddingLeft:'15px', fontSize:'21px', fontWeight:'700'}}> Maximize Impact, Harness The Power of PEVC Insights <br/>and Accelerate Your Job Search with Our</div>
<h1 className=" title" style={{color:'#bf2026', textAlign:'left', marginTop:'0px',paddingLeft:'15px', fontWeight:'700'}}>
ADVISORY COUNCIL</h1>
<br/><br/> 
<div class="col-md-3" style={{paddingBottom:'40px'}}>
<center><img className="main-img-1" src="https://winpeforum.com/assets/ignite/CharuGulati.png" alt="About Image" style={{width:'70%'}}/>
<h3 style={{textAlign:'center',color:'#bf2026', fontWeight:'500'}}>Charu Gulati</h3>
<p style={{color:'#22316b', fontSize:'16px', marginBottom:'0px'}}>Group Head Human Resources</p>
<img className="main-img-1" src="https://winpeforum.com/assets/ignite/everstone.png" alt="About Image" style={{width:'45%'}}/>
</center>
</div>

<div class="col-md-3"  style={{paddingBottom:'40px'}}>
<center><img className="main-img-1" src="https://winpeforum.com/assets/ignite/JoylynLargo.png" alt="About Image" style={{width:'70%'}}/>
<h3 style={{textAlign:'center',color:'#bf2026', fontWeight:'500'}}>Joylyn Largo-Afonso</h3>
<p style={{color:'#22316b', fontSize:'16px', marginBottom:'0px'}}>Director</p>
<img className="main-img-1" src="https://winpeforum.com/assets/ignite/truenorth.png" alt="About Image" style={{width:'45%'}}/>
</center>
</div>

<div class="col-md-3"  style={{paddingBottom:'40px'}}>
<center><img className="main-img-1" src="https://winpeforum.com/assets/ignite/PoonamPuri.png" alt="About Image" style={{width:'70%'}}/>
<h3 style={{textAlign:'center',color:'#bf2026', fontWeight:'500'}}>Poonam Puri</h3>
<p style={{color:'#22316b', fontSize:'16px', marginBottom:'0px'}}>Human Resources Advisor - Asia Pacific</p>
<img className="main-img-1" src="https://winpeforum.com/assets/ignite/cdpq.png" alt="About Image" style={{width:'45%'}}/>
</center>
</div>


<div class="col-md-3"  style={{paddingBottom:'40px'}}>
<center><img className="main-img-1" src="https://winpeforum.com/assets/ignite/PriyankaFernandes.png" alt="About Image" style={{width:'70%'}}/>
<h3 style={{textAlign:'center',color:'#bf2026', fontWeight:'500'}}>Priyanka Fernandes </h3>
<p style={{color:'#22316b', fontSize:'16px', marginBottom:'0px'}}>HR Business Partner</p>
<img className="main-img-1" src="https://winpeforum.com/assets/ignite/blackstone.png" alt="About Image" style={{width:'45%'}}/>
</center>
</div>

 <div class="col-md-3">&nbsp;</div>
 

<div class="col-md-3"  style={{paddingBottom:'40px'}}>
<center><img className="main-img-1" src="https://winpeforum.com/assets/ignite/SaipriyaSarangan.png" alt="About Image" style={{width:'70%'}}/>
<h3 style={{textAlign:'center',color:'#bf2026', fontWeight:'500'}}>Saipriya Sarangan</h3>
<p style={{color:'#22316b', fontSize:'16px', marginBottom:'0px'}}>Chief People Officer</p>
<img className="main-img-1" src="https://winpeforum.com/assets/ignite/peakxv.png" alt="About Image" style={{width:'45%'}}/>
</center>
</div>

<div class="col-md-3"  style={{paddingBottom:'40px'}}>
<center><img className="main-img-1" src="https://winpeforum.com/assets/ignite/UnmeshRai.png" alt="About Image" style={{width:'70%'}}/>
<h3 style={{textAlign:'center',color:'#bf2026', fontWeight:'500'}}>Unmesh Rai  </h3>
<p style={{color:'#22316b', fontSize:'16px', marginBottom:'0px'}}>Head of HR</p>
<img className="main-img-1" src="https://winpeforum.com/assets/ignite/cc2.png" alt="About Image" style={{width:'45%'}}/>
</center>
</div>
 

              </div> </div>
<div style={{backgroundImage:'url(https://winpeforum.com/assets/ignite/bg5.png)', height:'auto', minHeight:'540px' , width:'100%',  backgroundSize:'cover', paddingBottom:'45px'}}>
    <div className="container"><br/><br/> 
    <div className="top_text" style={{width:'100%', textAlign: 'left', color:'#ffffff' , paddingLeft:'15px', fontSize:'21px', fontWeight:'500'}}> Power Up with Our Free PEVC Career-Boosting</div>
<h1 className=" title" style={{color:'#ffffff', textAlign:'left', marginTop:'0px',paddingLeft:'15px', fontWeight:'700'}}>
RESOURCES</h1>
<br/><br/><br/>
  
        <div class="col-sm-6 col-md-5-5 col-lg-1-5">
        <a href="/trainings/"><img className="main-img-1" src="https://winpeforum.com/assets/ignite/pw1.png" alt="About Image" style={{width:'100%'}}/></a>
        </div>
        <div class="col-sm-6 col-md-3-5 col-lg-1-5">
        <a href="/RecruiterInsights/"><img className="main-img-1" src="https://winpeforum.com/assets/ignite/pw2.png" alt="About Image" style={{width:'100%'}}/></a>
        </div>
        <div class="col-sm-6 col-md-2-5 col-lg-1-5">
        <a href="/PeerSpeak/"><img className="main-img-1" src="https://winpeforum.com/assets/ignite/pw3.png" alt="About Image" style={{width:'100%'}}/></a>
        </div>
        <div class="col-sm-6 col-md-4-5 col-lg-1-5">
        <a href="/VisionaryVoices/"><img className="main-img-1" src="https://winpeforum.com/assets/ignite/pw4.png" alt="About Image" style={{width:'100%'}}/></a>
        </div>
        <div class="col-sm-6 col-md-4-5 col-lg-1-5"> 
        <a href="#"><img className="main-img-1" src="https://winpeforum.com/assets/ignite/pw5.png" alt="About Image" style={{width:'100%'}}/></a>
        </div>
</div>
</div> 


{/* 
<div className="container " style={{paddingTop:'30px'}}>
            
        
            <h1 className=" title" style={{color:'#bf2026', textAlign:'left', fontWeight:'700'}}>
                
            Uncover <i>Premier Job</i> Opportunities
</h1><br/><br/>

            <div className="col-lg-4">
            <div  style={{backgroundColor:'#22316b', height:'290px', borderRadius:'30px'}} >
<div style={{ padding:'20px', fontFamily:'Lato', color:'#fff'}}>
<h3 style={{color:'#fff'}}>Vice President, Investments</h3>
  <p>
  <b style={{textAlign:'left'}}>Location:</b> Bangalore<br/><br/>

  <b style={{textAlign:'left'}}>Company:</b> Start-up venture capital firm focused on investing in young entrepreneurs to create global impact.<br/><br/></p>
  <button class="btn" style={{color:'#22316b', backgroundColor:'#fff',borderRadius:'20px', width:'100%'}}>View JD</button>
    </div>
<br/> <br/> 
 
            </div>
              </div>
             
              <div className="col-lg-4">
            <div  style={{backgroundColor:'#22316b', height:'290px', borderRadius:'30px'}} >
<div style={{ padding:'20px', fontFamily:'Lato', color:'#fff'}}>
<h3 style={{color:'#fff'}}>Vice President, Investments</h3>
  <p>
  <b style={{textAlign:'left'}}>Location:</b> Bangalore<br/><br/>

  <b style={{textAlign:'left'}}>Company:</b> Start-up venture capital firm focused on investing in young entrepreneurs to create global impact.<br/><br/></p>
  <button class="btn" style={{color:'#22316b', backgroundColor:'#fff',borderRadius:'20px', width:'100%'}}>View JD</button>
    </div>
<br/> <br/> 
 
            </div>
              </div>
              <div className="col-lg-4">
            <div  style={{backgroundColor:'#22316b', height:'290px', borderRadius:'30px'}} >
<div style={{ padding:'20px', fontFamily:'Lato', color:'#fff'}}>
<h3 style={{color:'#fff'}}>Vice President, Investments</h3>
  <p>
  <b style={{textAlign:'left'}}>Location:</b> Bangalore<br/><br/>

  <b style={{textAlign:'left'}}>Company:</b> Start-up venture capital firm focused on investing in young entrepreneurs to create global impact.<br/><br/></p>
  <button class="btn" style={{color:'#22316b', backgroundColor:'#fff',borderRadius:'20px', width:'100%'}}>View JD</button>
    </div>
<br/> <br/> 
 
            </div>
              </div>
              
            
          
         
             </div>
             <br/> <br/> */}



<div style={{backgroundImage:'url(https://winpeforum.com/assets/ignite/bg9.jpg)', height:'auto', minHeight:'540px' , width:'100%',  backgroundSize:'cover', paddingBottom:'45px'}}>
    <div className="container"><br/><br/> 
  
<h1 className=" title" style={{color:'#ffffff', textAlign:'left', marginTop:'0px',paddingLeft:'15px', fontWeight:'600',fontFamily:'Lato'}}>
Power <span style={{color:'#bf2026', fontStyle:'italic'}}>Sessions:</span> Calendar</h1>
<div className="top_text" style={{width:'100%', textAlign: 'left', color:'#ffffff' , paddingLeft:'15px', fontSize:'21px', fontWeight:'500'}}> Join us on an impactful learning journey with our exclusive training 
sessions,<br/> tailored to ignite your skills and knowledge.</div>
<br/><br/><br/>
<div class="col-md-3">
<a href="https://lu.ma/j51hb3jt"><img className="main-img-1" src="https://winpeforum.com/assets/ignite/power1.png" alt="About Image" style={{width:'100%'}}/></a>
</div>
<div class="col-md-3">
 <img className="main-img-1" src="https://winpeforum.com/assets/ignite/power2.png" alt="About Image" style={{width:'100%'}}/> 
</div>
<div class="col-md-3">
 <img className="main-img-1" src="https://winpeforum.com/assets/ignite/power3.png" alt="About Image" style={{width:'100%'}}/> 
</div>
<div class="col-md-3">
 <img className="main-img-1" src="https://winpeforum.com/assets/ignite/power4.png" alt="About Image" style={{width:'100%'}}/> 
</div></div>
</div> 

 

<div className="container " style={{paddingTop:'30px'}}>
            
        
            <h1 className=" title" style={{color:'#bf2026', textAlign:'left', fontWeight:'700'}}>
                
            TESTIMONIALS</h1><br/><br/>

            <div className="col-lg-4">
            <div  style={{backgroundColor:'#f2f2f2', height:'390px'}} >
<p style={{fontSize:'20px', padding:'35px',textAlign:'center', fontFamily:'Lato'}}>This was a very insightful, valuable session - appreciate the panelists for taking out their time - and also for my CV review :) And big thanks to Winpe for hosting it</p>
<br/> <br/> 
<h3 style={{color:'#22316b', fontWeight:'600', textAlign:'center',  fontFamily:'Lato'}}>- Dhwani Nanavati</h3>
            </div>
              </div>
             
              <div className="col-lg-4">
              <div  style={{backgroundColor:'#d7d7d7', height:'390px'}} >
<p style={{fontSize:'20px', padding:'35px',textAlign:'center', fontFamily:'Lato'}}><br/>   <br/> <br/>Amazing platform for women willing to pursue their career in PE. Kudos !!</p>
<br/> <br/> 
<h3 style={{color:'#22316b', fontWeight:'600', textAlign:'center',  fontFamily:'Lato'}}>- Snehansu Pradhan</h3>
            </div>
              </div>
             
              <div className="col-lg-4">
              <div  style={{backgroundColor:'#f2f2f2', height:'390px'}} >
<p style={{fontSize:'20px', padding:'35px',textAlign:'center', fontFamily:'Lato'}}>Shoutout to Winpe Forum for giving me the opportunity to interact with Capital Markets expert Bhavna Thakur! The 1:1 session was extremely insightful. Great initiative and looking forward to more such opportunities! This was great…</p>
 
<h3 style={{color:'#22316b', fontWeight:'600', textAlign:'center',  fontFamily:'Lato'}}>- Shriya Bahul</h3>
            </div>
              </div>
           <div className="col-md-6"><br/><br/><br/>
           <iframe
                            className="resp-iframe"
                            style={{ margin: "0 auto", height:'300px' }}
                            width="100%"
                            src="https://www.youtube.com/embed/KMV9_jzBqy4?si=-nzl6EeuKApwqGQG"
                            frameBorder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          ></iframe>
           </div>
           <div className="col-md-6"><br/><br/><br/>
           <iframe
                            className="resp-iframe"
                            style={{ margin: "0 auto", height:'300px'  }}
                            width="100%"
                            src="https://www.youtube.com/embed/GEApxHfrYC4?si=S9o2QrWr-QPN0lL9"
                            frameBorder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          ></iframe>
           </div>
             </div>
             <br/> <br/> 
             
     
<div style={{backgroundImage:'url(https://winpeforum.com/assets/ignite/bg8.jpg)', height:'auto',   width:'100%',  backgroundSize:'cover', paddingBottom:'45px'}}>
<div className="container"> 
 
 
 
 <img className="main-img-1" src="https://winpeforum.com/assets/ignite/whojoin.png" alt="About Image" style={{width:'100%'}}/> 
 
 </div>
</div> 
             
             <div class="container">
             <div class="row" style={{paddingTop:'30px'}}>
  <div class="col-md-12">
  <h1 className=" title" style={{color:'#bf2026', textAlign:'left', fontWeight:'700'}}>
                
                FAQs</h1><br/><br/>
    <div class="tabs">
      <div class="tab">
        <input type="checkbox" id="chck1"/>
        <label class="tab-label" for="chck1">What is Winpe Ignite?
        </label>
        <div class="tab-content">
        <p>Winpe Ignite is an initiative designed to support and enhance women's entry into the Private Equity and Venture Capital (PEVC) sector. It offers a range of resources, including training programs, sessions with CHROs, and job postings to help women advance their careers in this field.</p>
        </div>
      </div>
      <div class="tab">
        <input type="checkbox" id="chck2"/>
        <label class="tab-label" for="chck2">  What does the components of the Winpe Ignite portal?
        </label>
        <div class="tab-content">
        <p>The Winpe Ignite Portal provides access to various features including:
<ul><li>Specialized training programs tailored to the PEVC sector.</li>
<li>Exclusive sessions with CHROs and industry leaders for career guidance and networking.</li>
<li>Job postings and career opportunities within the PEVC sector.</li>
<li>3-5 days short training courses in collaboration with prestigious training and knowledge providers (Paid)</li>
<li>Links to Recommended free online knowledge resources</li></ul>

</p>
        </div>
      </div>
      <div class="tab">
        <input type="checkbox" id="chck3"/>
        <label class="tab-label" for="chck3"> How can I sign-up for Winpe Ignite?       </label>
        <div class="tab-content">
        <p>You can sign-up by visiting our website and following the sign-up process.</p>
        </div>
      </div>
      <div class="tab">
        <input type="checkbox" id="chck4"/>
        <label class="tab-label" for="chck4">Are the training programs and sessions live or recorded?
        </label>
        <div class="tab-content">
        <p>The training programs and sessions with CHROs are typically conducted live.</p>
        </div>
      </div>
      <div class="tab">
        <input type="checkbox" id="chck5"/>
        <label class="tab-label" for="chck5">Can I access Winpe Ignite from anywhere?</label>
        <div class="tab-content">
        <p>Yes, it is accessible online from anywhere, allowing you to take advantage of the resources and opportunities at your convenience.</p>
        </div>
      </div>
      <div class="tab">
        <input type="checkbox" id="chck6"/>
        <label class="tab-label" for="chck6">  What kind of job postings will be available on the portal?
        </label>
        <div class="tab-content">
        <p>The job postings on the Ignite Portal will feature a variety of opportunities within the PEVC sector, including roles in private equity, venture capital, and related fields. These postings will be curated to match the interests and career goals of women in the sector.</p>
        </div>
      </div>
      <div class="tab">
        <input type="checkbox" id="chck7"/>
        <label class="tab-label" for="chck7">How often is new content and job postings updated on the portal?
        </label>
        <div class="tab-content">
        <p>Content and job postings are updated regularly to ensure that you have access to the latest opportunities and resources. Registrants will receive notifications about new updates and upcoming events.</p>
        </div>
      </div>
      <div class="tab">
        <input type="checkbox" id="chck8"/>
        <label class="tab-label" for="chck8">What should I do if I encounter any issues or have feedback about the portal?</label>
        <div class="tab-content">
        <p>If you experience any issues or have feedback about the portal, please contact our support team at info@winpeforum.com or at +91 8920503049 (WhatsApp only). We are here to assist you and ensure you have a smooth experience.</p>
        </div>
      </div>
      
     
     
     
    </div><br/><br/><br/>
  </div>
 
</div>
             </div>
             <div  >
 
 </div>
  

            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
           
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/WinpeIgnite/index.js